import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Spinner } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { Calendar3, ChevronDoubleRight, Share } from 'react-bootstrap-icons'
import { WhatsappIcon, FacebookIcon } from 'react-share'
import BannerImg from '../assets/images/banners/Banner1.webp'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'

const News = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [news, setNews] = useState([])
    const [contentLoading, setContentLoading] = useState(true)
    const [activeShareDropdown, setActiveShareDropdown] = useState(null)

    const copyToClipboard = async (url) => {
        try {
            await navigator.clipboard.writeText(url)
            alert('Link copied to clipboard!')
        } catch (err) {
            console.error('Failed to copy:', err)
        }
        setActiveShareDropdown(null)
    }

    const toggleShareDropdown = (index) => {
        setActiveShareDropdown(activeShareDropdown === index ? null : index)
    }

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/news/website`)
            .then((res) => {
                if (res.data.news.length > 0) {
                    setNews(res.data.news)
                } else {
                    setNews([])
                }
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setContentLoading(false)
            })
    }, [])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title> Dubai Real Estate News - Market Trends & Updates </title>
                <meta
                    name="description"
                    content="Stay updated with the latest news on Dubai real estate with 800 Homes. Get insights on property trends, market updates, and expert analysis from our team of brokers."
                />

                <meta property="og:type" content="website" />
                <meta property="og:title" content="Dubai Real Estate News - Market Trends & Updates" />
                <meta
                    property="og:description"
                    content="Stay updated with the latest news on Dubai real estate with 800 Homes. Get insights on property trends, market updates, and expert analysis from our team of brokers."
                />
                <meta property="og:url" content="https://800homes.ae/" />
                <meta property="og:site_name" content="800homes" />
                <meta property="og:image" content="https://800homes.ae/og.webp" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:secure_url" content="https://800homes.ae/og.webp" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:description"
                    content="Stay updated with the latest news on Dubai real estate with 800 Homes. Get insights on property trends, market updates, and expert analysis from our team of brokers."
                />
                <meta name="twitter:title" content="Dubai Real Estate News - Market Trends & Updates" />
                <meta name="twitter:image" content="https://800homes.ae/og.webp" />
                <link rel="canonical" href="https://800homes.ae/news" />
            </Helmet>
            <Helmet>
                <title>Latest News | 800 Homes - Real Estate Brokerage</title>
            </Helmet>
            <Header />

            <section
                id="website-responsive"
                className="container-fluid common-banner shadow-800homes"
                style={{ backgroundImage: `url(${BannerImg})` }}
            >
                <div className="row justify-content-center align-items-center">
                    <div className="col-11 col-lg-10">
                        <h1 className="lh-sm fw-600 banner-title text-uppercase text-white text-center">Latest News</h1>
                        <div></div>
                    </div>
                </div>
            </section>

            <section className="pt-5 mt-md-5" />

            <section id="website-responsive" className="container-fluid py-4 font-pri">
                <div className="row justify-content-center gap-5">
                    {contentLoading ? (
                        <div className="col-md-12 col-sm-12 text-center">
                            <Spinner animation="border" variant="white" />
                        </div>
                    ) : (
                        <>
                            {news.length > 0 ? (
                                <>
                                    {news.map((news, index) => {
                                        const newsUrl = `${window.location.origin}/news/${news?.slug}`
                                        return (
                                            <>
                                                <Helmet>
                                                    <meta property="og:image" content={news?.image} />
                                                    <meta property="og:image:width" content="1200" />
                                                    <meta property="og:image:height" content="630" />
                                                    <meta property="og:image:secure_url" content={news?.image} />
                                                    <meta name="twitter:image" content={news?.image} />
                                                </Helmet>
                                                <div className="w-blogs hover-blogs border-white border-1 border-bottom border-1 border border-white p-0">
                                                    <div className="image-box">
                                                        <Link to={`/news/${news?.slug}`} state={{ news }} className="">
                                                            <img
                                                                className="w-100"
                                                                src={news?.image}
                                                                alt={news?.image_alt || news?.title}
                                                            />
                                                        </Link>
                                                    </div>
                                                    <div className="py-4 px-3">
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <div className="flex-grow-1">
                                                                <h2 className="fs-ss-20 pt-2">
                                                                    <Link
                                                                        to={`/news/${news?.slug}`}
                                                                        state={{ news }}
                                                                        className="text-white text-decoration-none align-text-line2"
                                                                    >
                                                                        <div style={{ fontWeight: '500' }}>
                                                                            {news?.title}
                                                                        </div>
                                                                    </Link>
                                                                </h2>
                                                                <div className="text-grey pt-2 fs-ss-15 fw-300">
                                                                    {news?.short_description}
                                                                </div>
                                                                <div className="text-grey pt-3 fs-ss-15">
                                                                    <Calendar3 className="me-3" />
                                                                    Date:{' '}
                                                                    {new Date(news?.createdAt).toLocaleDateString(
                                                                        'en-US',
                                                                        {
                                                                            month: 'long',
                                                                            day: '2-digit',
                                                                            year: 'numeric',
                                                                        },
                                                                    )}
                                                                </div>
                                                                <div className="fs-ss-14 pt-3">
                                                                    <Link
                                                                        to={`/news/${news?.slug}`}
                                                                        state={{ news }}
                                                                        className="text-decoration-none fw-500 text-ss-primary"
                                                                    >
                                                                        Read More <ChevronDoubleRight className="" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="position-relative ms-3">
                                                                <button
                                                                    className="btn btn-sm text-white border-0 bg-transparent"
                                                                    onClick={() => toggleShareDropdown(index)}
                                                                    style={{ padding: '4px' }}
                                                                >
                                                                    <Share size={20} />
                                                                </button>
                                                                {activeShareDropdown === index && (
                                                                    <div className="position-absolute end-0 top-100 mt-2 bg-dark border border-white rounded-1 p-2 z-10">
                                                                        <div className="d-flex flex-column gap-2">
                                                                            <a
                                                                                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(news?.title + ' ' + newsUrl)}`}
                                                                                className="d-flex align-items-center text-white text-decoration-none"
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                <WhatsappIcon size={24} round />
                                                                                <span className="ms-2 fs-ss-14">
                                                                                    WhatsApp
                                                                                </span>
                                                                            </a>
                                                                            <a
                                                                                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(newsUrl)}`}
                                                                                className="d-flex align-items-center text-white text-decoration-none"
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                <FacebookIcon size={24} round />
                                                                                <span className="ms-2 fs-ss-14">
                                                                                    Facebook
                                                                                </span>
                                                                            </a>
                                                                            <button
                                                                                className="btn btn-sm btn-outline-light d-block align-items-center text-center"
                                                                                onClick={() => copyToClipboard(newsUrl)}
                                                                            >
                                                                                <div className="fs-ss-14">
                                                                                    Copy Link
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                </>
                            ) : (
                                <div className="col-md-12 col-sm-12 text-center">
                                    <div
                                        className="fs-zk-22 text-white text-montserrat mb-2"
                                        style={{ fontWeight: '600' }}
                                    >
                                        No News Found
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </section>

            <section className="pt-5 mt-md-5" />

            <Footer />
        </>
    )
}

export default News
